<template>
  <v-container class="margen_paginas pt-7" fluid>

    <TablaDatosAPI
      titulo="Roles de operador"
      icono="mdi-account-details"
      tabla="c_rolope"
      :campos="['id_rolope', 'des+', '__perope_rolope']"
      permitirAnadir
      permitirModificar
      permitirEliminar
      @datos-actualizados="datosActualizados"
    >

      <template v-slot:[`item.__perope_rolope__VT`]="{ item }">
        <div style="max-width: 55vw">
        <v-chip class="mt-1 ml-2 text-caption" v-for="(atributo, i) in item.__perope_rolope" :key="i">
          {{ dominioValoresPermisos[JSON.stringify (atributo)] }}
        </v-chip>
        </div>
      </template>

    </TablaDatosAPI>
  </v-container>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  data() {
    return {
      dominioValoresPermisos: null
    }
  },
  methods: {
    datosActualizados (definicionCampos) {
      this.dominioValoresPermisos = definicionCampos.__perope_rolope.dominio_valores;
    }
  }
};
</script>

<style>
</style>